var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 169,
    viewBox: "0 0 127 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 134.25C16.5 134.25 15.7193 134.161 14.4369 133.949C10.0237 133.22 -0.330579 131.035 -5.24995 126C-15.7917 115.211 -5.24995 87.375 -5.24995 87.375C-5.24995 87.375 9.33792 91.1764 15.6528 98.3256L16.5 73.5C16.5 73.5 -0.0695429 60.9331 0.750047 49.875C1.37768 41.4068 12.375 31.5 12.375 31.5C12.375 31.5 22.2939 38.5425 24.75 45.375C28.6221 56.1465 16.5 73.5 16.5 73.5L15.6528 98.3256C15.955 98.6678 16.2382 99.0176 16.5 99.375C24.5481 110.362 16.5 134.25 16.5 134.25Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.625 123.75C110.912 125.586 117 126 117 126C117 126 121.437 120.482 122.625 116.25C124.759 108.645 124.911 101.469 118.875 96.375C115.336 93.3882 107.625 92.625 107.625 92.625C107.625 92.625 97.0131 117.823 107.625 123.75Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 177.375L16.5 134.25M16.5 134.25C16.5 134.25 1.09887 132.498 -5.24995 126C-15.7917 115.211 -5.24995 87.375 -5.24995 87.375C-5.24995 87.375 10.7676 91.549 16.5 99.375C24.5481 110.362 16.5 134.25 16.5 134.25ZM16.5 73.5C16.5 73.5 -0.0695431 60.9331 0.750047 49.875C1.37768 41.4068 12.375 31.5 12.375 31.5C12.375 31.5 22.294 38.5425 24.75 45.375C28.6221 56.1465 16.5 73.5 16.5 73.5ZM16.5 73.5L12.7501 183.375M118.875 181.875L117 126M117 126C117 126 110.912 125.586 107.625 123.75C97.0131 117.823 107.625 92.625 107.625 92.625C107.625 92.625 115.336 93.3882 118.875 96.375C124.911 101.469 124.759 108.645 122.625 116.25C121.437 120.482 117 126 117 126Z",
    stroke: "black",
    strokeWidth: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.142 122.633C119.915 127.971 107.234 129.411 107.234 129.411C107.234 129.411 100.608 109.787 107.234 100.76C111.954 94.3312 125.142 90.9022 125.142 90.9022C125.142 90.9022 133.822 113.77 125.142 122.633Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.202 60.0954C119.686 53.1386 110.631 45 110.631 45C110.631 45 102.464 50.7855 100.442 56.3985C97.2538 65.2475 107.234 79.5037 107.234 79.5037C107.234 79.5037 120.877 69.1798 120.202 60.0954Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2065 120.785C29.5001 122.293 24.4876 122.633 24.4876 122.633C24.4876 122.633 20.8341 118.1 19.8562 114.623C18.0991 108.376 17.9738 102.481 22.9438 98.2958C25.8578 95.8421 32.2065 95.2152 32.2065 95.2152C32.2065 95.2152 40.9438 115.915 32.2065 120.785Z",
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M107.625 152.625L107.234 129.411M107.234 129.411C107.234 129.411 119.915 127.971 125.142 122.633C133.822 113.77 125.142 90.9022 125.142 90.9022C125.142 90.9022 111.954 94.3312 107.234 100.76C100.608 109.787 107.234 129.411 107.234 129.411ZM107.234 79.5037C107.234 79.5037 120.877 69.1798 120.202 60.0954C119.686 53.1386 110.631 45 110.631 45C110.631 45 102.464 50.7855 100.442 56.3985C97.2538 65.2475 107.234 79.5037 107.234 79.5037ZM107.234 79.5037L94.875 148.875M24 151.5L24.4876 122.633M24.4876 122.633C24.4876 122.633 29.5001 122.293 32.2065 120.785C40.9438 115.915 32.2065 95.2152 32.2065 95.2152C32.2065 95.2152 25.8578 95.8421 22.9438 98.2958C17.9738 102.481 18.0991 108.376 19.8562 114.623C20.8341 118.1 24.4876 122.633 24.4876 122.633Z",
    stroke: "black",
    strokeWidth: 0.75
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1619 57.3523C98.1619 57.3523 102.555 120.453 63.0168 120.453C23.4783 120.453 26.6511 57.3523 26.6511 57.3523C26.6511 57.3523 24.7416 19.8247 64.3549 19.8247C101.227 19.8247 98.1619 57.3523 98.1619 57.3523Z",
    fill: "#F6F6F4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1619 57.3523C98.1619 57.3523 102.555 120.453 63.0168 120.453C23.4783 120.453 26.6511 57.3523 26.6511 57.3523C26.6511 57.3523 24.7416 19.8247 64.3549 19.8247C101.227 19.8247 98.1619 57.3523 98.1619 57.3523Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.13,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6863 77.3888V83.4695C60.6863 83.8939 60.7686 84.303 60.9179 84.6771C61.5062 86.1464 63.2008 86.849 64.7323 86.4414L66.5153 85.9699",
    stroke: "#1A1A1A",
    strokeWidth: 1.088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3231 69.8525C51.3231 71.6594 49.8556 73.1241 48.0451 73.1241C46.2347 73.1241 44.7656 71.6594 44.7656 69.8525C44.7656 68.0472 46.2347 66.581 48.0451 66.581C49.8556 66.581 51.3231 68.0472 51.3231 69.8525Z",
    fill: "#1A1A1A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8733 69.8525C81.8733 71.6594 80.4057 73.1241 78.5953 73.1241C76.7849 73.1241 75.3158 71.6594 75.3158 69.8525C75.3158 68.0472 76.7849 66.581 78.5953 66.581C80.4057 66.581 81.8733 68.0472 81.8733 69.8525Z",
    fill: "#1A1A1A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5944 93.7137C55.5944 93.7137 58.816 95.7213 63.0647 95.7213C67.3134 95.7213 70.535 93.7137 70.535 93.7137",
    stroke: "#1A1A1A",
    strokeWidth: 1.088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9292 57.0908C55.7585 57.4194 54.9493 61.4255 54.9493 61.4255L36.9181 63.3617L41.2171 60.2802C42.3144 59.5761 43.5381 59.0863 44.8182 58.8399L55.9292 57.0908Z",
    fill: "#1A1A1A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7085 57.0908C68.8792 57.4194 69.6884 61.4255 69.6884 61.4255L87.7196 63.3617L83.4206 60.2802C82.3234 59.5761 81.1012 59.0863 79.8195 58.8399L68.7085 57.0908Z",
    fill: "#1A1A1A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4116 89.2473C98.0861 92.9203 103.249 90.5173 106.242 85.7354C109.237 80.9551 110.634 71.393 106.242 68.8028C101.852 66.2112 98.1501 71.5512 98.1501 71.5512C98.1501 71.5512 97.0819 81.2183 96.3031 84.8335L95.4116 89.2473Z",
    fill: "#F6F6F4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4116 89.2473C98.0861 92.9203 103.249 90.5173 106.242 85.7354C109.237 80.9551 110.634 71.393 106.242 68.8028C101.852 66.2112 98.1501 71.5512 98.1501 71.5512C98.1501 71.5512 97.0819 81.2183 96.3031 84.8335L95.4116 89.2473Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.149,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9713 80.4439C100.484 73.1708 105.763 74.7784 105.763 74.7784",
    stroke: "#1A1A1A",
    strokeWidth: 0.575,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7037 76.8466C99.7037 76.8466 105.088 79.7212 101.531 84.0391",
    stroke: "#1A1A1A",
    strokeWidth: 0.575,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.325 89.2087C26.652 92.8803 21.8181 90.5167 18.8236 85.7364C15.8306 80.9546 14.4331 71.3924 18.8236 68.8023C23.2156 66.2121 26.9172 71.5521 26.9172 71.5521",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.325 89.2087C26.652 92.8803 21.8181 90.5167 18.8236 85.7364C15.8306 80.9546 14.4331 71.3924 18.8236 68.8023C23.2156 66.2121 26.9172 71.5521 26.9172 71.5521",
    stroke: "#1A1A1A",
    strokeWidth: 1.149,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3048 74.7791C19.3048 74.7791 24.2546 73.132 27.7657 80.4036",
    stroke: "#1A1A1A",
    strokeWidth: 0.575,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3635 76.8466C25.3635 76.8466 19.9794 79.7212 23.5363 84.0391",
    stroke: "#1A1A1A",
    strokeWidth: 0.575,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1232 16.746C74.4118 13.3969 68.1179 12.1817 62.3681 12.4068C56.6198 12.1817 50.3259 13.3969 43.613 16.746C13.8962 31.5751 26.298 71.2199 26.298 71.2199L26.4443 69.5088C27.3282 68.3438 32.1499 61.673 34.157 52.7298H90.2607C92.2738 63.5772 97.8652 70.0396 98.0648 70.6206C98.1379 69.8617 98.1776 69.0708 98.2035 68.2662L98.8771 71.2199C98.8771 71.2199 110.841 31.5751 81.1232 16.746Z",
    fill: "#1A1A1A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M104.238 8.37626C104.238 20.2411 94.601 29.861 82.7112 29.861C70.8215 29.861 61.1841 20.2411 61.1841 8.37626C61.1841 -3.49009 70.8215 -13.11 82.7112 -13.11C94.601 -13.11 104.238 -3.49009 104.238 8.37626Z",
    fill: "#1A1A1A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M107.436 152.904C107.436 152.904 81.2185 147.138 79.3792 138.584V115.747",
    stroke: "#1A1A1A",
    strokeWidth: 1.149,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4715 115.69V138.585C46.4715 138.585 39.2587 149.414 19.4811 152.834",
    stroke: "#1A1A1A",
    strokeWidth: 1.149,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M147.508 206.556C147.508 177.465 118.809 158.654 110.283 153.706C108.908 152.909 107.215 152.918 105.867 153.761C96.9196 159.355 60.0464 179.101 20.4637 153.2C19.7139 152.708 18.7584 152.66 17.9751 153.096C11.1631 156.892 -20.3199 176.085 -20.3199 206.556",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M147.508 206.556C147.508 177.465 118.809 158.654 110.283 153.706C108.908 152.909 107.215 152.918 105.867 153.761C96.9196 159.355 60.0464 179.101 20.4637 153.2C19.7139 152.708 18.7584 152.66 17.9751 153.096C11.1631 156.892 -20.3199 176.085 -20.3199 206.556",
    stroke: "#1A1A1A",
    strokeWidth: 1.149,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3541 149.716C31.3541 149.716 58.9892 165.787 95.4585 149.637",
    stroke: "#1A1A1A",
    strokeWidth: 1.149,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6106 115.911C46.6106 115.911 53.4409 131.171 67.2965 130.199C67.2965 130.199 77.1777 130.106 79.5185 120.294L78.5447 115.911C78.5447 115.911 66.0819 124.77 46.6106 115.911Z",
    fill: "#1A1A1A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.93d3a3b9039f70c0e491693214c2e487.svg";
export { ForwardRef as ReactComponent };